import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  align-items: left;

  padding: 32px;

  .input {
    margin-top: 26px;

    display: flex;
    flex-direction: column;
    gap: 15px;

    b {
      color: #fb264b;
    }
  }

  span {
    font-weight: normal;
    font-size: 16px;
    line-height: 140%;

    color: ${props => props.theme.interface5};
  }
`;
